/* tslint:disable */
import { FieldsInterface } from '../../../Interfaces/Draft/FieldsInterface';
import { SettingsInterface } from '../../../Interfaces/Settings/SettingsInterface';
import { ModelInterface } from '../../../Interfaces/Settings/ModelInterface';
import { InvoiceHeaderInterface } from '../../../Interfaces/InvoiceHeaderInterface';
import { l, tsxl } from '../../../Other/Translation';
import { FieldInterface } from '../../../Interfaces/Draft/FieldInterface';
import { TestableInterface } from '../../common/interfaces/TestableInterface';
import { FieldCreator } from '../../common/FieldCreator';
import { Layout, LayoutColumn } from '../../common/Layout/Layout';
import { Input } from '../../common/Input/Input';
import { SchemaInterface } from '../../../Interfaces/Schema/SchemaInterface';
import { LabelKeys } from "../../../Interfaces/LabelsInterface";
import { correctReferenceNumber } from '../../../Other/functions/referenceNumberFunctions';
import { calculateDaysFromStartDate, transformDateFormatForMoment } from '../../../Other/functions/dateFunctions';
import { convertVatpctFromLocale } from '../../../Other/functions/vatFunctions';
import * as React from 'react';
import * as _ from 'lodash';
import { IntegerFormatter } from '../../../Other/Format/IntegerFormatter';
import { Format } from '../../../Other/Format/Format';
import { PercentageFormatter } from '../../../Other/Format/PercentageFormatter';
import * as moment from 'moment';

export interface InvoiceHeaderPropsInterface extends TestableInterface {
  fields: FieldsInterface;
  settings: SettingsInterface;
  locale: string;
  model: ModelInterface;
  schema: SchemaInterface;
  invalidFields: string[];
  country: string;
}

export interface InvoiceHeaderActionsInterface {
  onChange: (field: FieldInterface) => void;
}

export interface InvoiceHeaderStateInterface extends InvoiceHeaderInterface {
  focused?: boolean;
}

export class InvoiceHeader extends React.Component<InvoiceHeaderPropsInterface & InvoiceHeaderActionsInterface,
  InvoiceHeaderStateInterface> {
  private int: IntegerFormatter;

  constructor(props) {
    super(props);

    const format = Format.fromLocale(props.locale);
    format.numbers.isGrouped = false;
    this.int = new IntegerFormatter(format);

    this.state = {
      focused: false,
    };

    this.onFocusChange = this.onFocusChange.bind(this);
  }

  private onFocusChange({ focused }) {
    this.setState({ focused });
  }

  private getMap(fieldName: string) {
    const map = {};
    this.props.settings.managedFields[fieldName].forEach((name) => {
      // special handling for interest field
      switch (fieldName) {
        case 'PAYMENT_INTEREST':
          map[parseFloat(name)] = convertVatpctFromLocale(name, this.props.locale);
          break;
        case 'PAYMENT_TERMS':
          map[parseInt(name, 10)] = name + ' ' + l('days');
          break;
        default:
          map[name] = name;
      }
    });
    return map;
  }

  private getReferenceNumber() {
    let ref = '';
    if (this.props.fields.referenceNumber && /^[0-9]{1,20}$/.test(this.props.fields.referenceNumber.value)) {
      ref = this.props.fields.referenceNumber.value;
    }
    return ref;
  }

  private correctReferenceNumber(value) {
    return ['FI', 'AX'].includes(this.props.country) ? correctReferenceNumber(value) : value;
  }

  private changeReferenceNumber(value) {
    value = value.replace(/[^0-9]/g, '');
    if (!value || /^[0-9]{1,20}$/.test(value)) {
      this.props.onChange({ ...this.props.fields.referenceNumber, value: this.correctReferenceNumber(value) });
    }
  }

  private isDueDateVisible(): boolean {
    return true; // _isFieldVisible('dueDate', this.props.model, this.props.schema);
  }

  private isDueDateEditable(): boolean {
    return false; // !_isFieldVisible('paymentTime', this.props.model, this.props.schema);
  }

  public render(): JSX.Element {
    const type = 'invoice';
    const labels = LabelKeys[type];
    const now = moment();
    const defaultPaymentTerm = 30;
    const defaultDuedate = calculateDaysFromStartDate(now, defaultPaymentTerm);
    let isCreditNote = _.get(this.props.fields, 'creditnoteNumber.value', false);
    // const dateFormat = 'YYYY-DD-MM';
    if (isCreditNote !== false) {
      isCreditNote = true;
    }
    ;
    const dateFormat = transformDateFormatForMoment(this.props.settings.values.regional.longDate);
    const issueDate = _.get(this.props.fields, 'issueDate.value', false) || now.toISOString();
    const dueDate = _.get(this.props.fields, 'dueDate.value', false) || defaultDuedate.toISOString();
    const percentageFormatter = new PercentageFormatter(Format.fromLocale(this.props.locale), true);
    // noinspection TsLint
    return (
      <div data-automatio={this.props.automation} className="InvoiceHeader">
        <Layout>
          <LayoutColumn>
            <div className="tight">
              <div>
                <Input
                  automation={this.props.automation + '-invoiceNumber'}
                  value={this.props.fields.invoiceNumber ? this.props.fields.invoiceNumber.value : '0'}
                  align={'left'}
                  label={l(labels.entityNumber)}
                  onChange={(val) => {
                    let estimateNumber = val || '';
                    estimateNumber = estimateNumber.replace(/[^0-9]/g, '').trim();
                    this.props.onChange({ ...this.props.fields.invoiceNumber, value: estimateNumber });
                  }}
                />
              </div>
              <FieldCreator name="issueDate" model={this.props.model}
                schema={this.props.schema} translator={tsxl} props={{
                  automation: this.props.automation + '-date',
                  todayButton: l('Today'),
                  value: issueDate,
                  invalid: (this.props.invalidFields && this.props.invalidFields.indexOf('issueDate') >= 0),
                  locale: this.props.locale,
                  format: dateFormat,
                  onChange: (date) => {
                    this.props.onChange({ ...this.props.fields.issueDate, value: date });
                  }
                }} />
              <FieldCreator name="paymentTime" model={this.props.model}
                schema={this.props.schema} translator={tsxl} props={{
                  value: this.props.fields.paymentTime ? this.props.fields.paymentTime.value : '',
                  searchable: true,
                  searchPlaceholder: l('search.Default'),
                  map: this.getMap('PAYMENT_TERMS'),
                  automation: this.props.automation + '-paymentTerms',
                  onChange: (value) => {
                    this.props.onChange({ ...this.props.fields.paymentTime, value: parseInt(value, 10) });
                  },
                  disabled: isCreditNote
                }} />
              <FieldCreator name="dueDate" model={this.props.model} schema={this.props.schema} translator={tsxl} props={{
                automation: this.props.automation + '-dueDate',
                todayButton: l('Today'),
                value: dueDate,
                format: dateFormat,
                locale: this.props.locale,
                invalid: (this.props.invalidFields && this.props.invalidFields.indexOf('dueDate') >= 0),
                disabled: true
              }} />
              <FieldCreator name="externalReference" model={this.props.model}
                schema={this.props.schema} translator={tsxl} props={{
                  value: this.props.fields.externalReference ? this.props.fields.externalReference.value : '',
                  invalid: (this.props.invalidFields && this.props.invalidFields.indexOf('externalReference') >= 0),
                  automation: this.props.automation + '-externalReference',
                  onBlur: (value) => {
                    this.props.onChange({ ...this.props.fields.externalReference, value });
                  }
                }} />
              {
                this.props.fields.deduction && this.props.fields.deduction.visible &&
                <FieldCreator name="deduction" model={this.props.model}
                  schema={this.props.schema} translator={tsxl} props={{
                    align: 'left',
                    formatter: percentageFormatter,
                    value: this.props.fields.deduction ? this.props.fields.deduction.value : '',
                    invalid: (this.props.invalidFields && this.props.invalidFields.indexOf('deduction') >= 0),
                    automation: this.props.automation + '-deduction',
                    onBlur: (value) => {
                      value = Math.abs(value);
                      if (value > 100) { value = this.props.fields.deduction.value }
                      this.props.onChange({ ...this.props.fields.deduction, value });
                    }
                  }} />
              }
            </div>
          </LayoutColumn>
          <LayoutColumn>
            <div className="tight">
              <FieldCreator name="senderReference" model={this.props.model}
                schema={this.props.schema} translator={tsxl} props={{
                  automation: this.props.automation + '-senderReference',
                  labelPosition: 'top',
                  value: this.props.fields.senderReference ? this.props.fields.senderReference.value : '',
                  invalid: (this.props.invalidFields && this.props.invalidFields.indexOf('senderReference') >= 0),
                  onBlur: (value) => {
                    this.props.onChange({ ...this.props.fields.senderReference, value });
                  }
                }}>
              </FieldCreator>
              <FieldCreator name="description" model={this.props.model}
                schema={this.props.schema} translator={tsxl} props={{
                  automation: this.props.automation + '-message',
                  labelPosition: 'top',
                  value: this.props.fields.description ? this.props.fields.description.value : '',
                  invalid: (this.props.invalidFields && this.props.invalidFields.indexOf('description') >= 0),
                  onBlur: (value) => {
                    const description = this.props.fields.description || {
                      name: 'description',
                      value: '',
                      visible: true
                    };
                    this.props.onChange({ ...description, value });
                  },
                  maxLength: 3000,
                  showCounter: true
                }} />
            </div>
          </LayoutColumn>
        </Layout>
      </div>
    );
  }
}
